import { Goal } from 'shared/types/goal';
import { ID } from 'shared/types/id';

export const filterGoalsOnLifeArea = (goals: Goal[], lifeAreaId: ID) =>
  goals.filter(
    (goal) =>
      lifeAreaId === goal.lifeAreaId && !goal.archivedAt && !goal.parentIds,
  );
